var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, OnDestroy, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { ModalService, SidebarService } from '@ibe/services/ui';
import { INDRALoginModalComponent } from '@ibe.components/shared/login-modal/login-modal.indra.component';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { takeWhile } from 'rxjs/operators';
import * as fromStore from '../../../../store';
import * as UserActions from '@ibe/store/actions/user.actions';
import * as FlightsFilterActions from '@ibe/store/actions/flights-filter.actions';
import * as OptionsBarActions from '@ibe/store/actions/options-bar.actions';
import * as PromoVoucherActions from '@ibe/store/actions/promo-vouchers.actions';
import { Location } from '@angular/common';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRALanguageMarketService } from '@ibe.services/language-market-indra.service';
import { INDRALocationService } from '@ibe.services/location.indra.service';
import { INDRAHeaderService } from '@ibe.services/header.indra.service';
import { INDRAStorageService } from '@ibe.services/storage.indra.service';
import { INDRAPaymentService } from '@ibe.services/payment.indra.service';
import { INDRAAuthenticationService } from '@ibe.services/authentication.indra.service';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import * as PaymentMethodsActions from '../../../../store/actions/payment-method.action';
import * as ConfirmModalActions from '@ibe/store/actions/confirm-modal.actions';
import { TAP_HEADER_MILES_AND_GO_MILES, TAP_HEADER_MILES_AND_GO_MILS, TAP_HEADER_MILES_AND_GO_SILVER, TAP_HEADER_MILES_AND_GO_GOLD, TAP_HEADER_MILES_AND_GO_NAVIGATOR, TAP_HEADER_MILES_AND_GO_HONORARY_GOLD, DEFAULT_LANGUAGE, DEFAULT_MARKET, TAP_HEADER_CLUB_TAP_BASIC, TAP_HEADER_CLUB_TAP_EXTRA, TAP_HEADER_CLUB_TAP_PLATINUM, TAP_HEADER_CLUB_TAP_PLATINUM_PLUS, TAP_HEADER_CLUB_TAP_DIAMOND, TAP_HEADER_CLUB_TAP_TOP, SESSION_VAR_KEY_PAYMENT_SESSION_ID } from '@ibe.config';
import { INDRADiscountService } from '@ibe.services/discount.indra.service';
import { INDRAConfirmModalComponent } from '@ibe.components/shared/confirm-modal/confirm-modal.indra.component';
import { INDRAIbeAdminConfigService } from "@ibe.services/ibeadmin-config.service";
import { INDRAURLService } from "@ibe.services/url.indra.service";
import * as FlightInformationActions from '@ibe/store/actions/flight-information.indra.actions';
import * as OutboundFlightInformationActions from '@ibe/store/actions/outbound-flight-information.indra.actions';
import * as InboundFlightInformationActions from '@ibe/store/actions/inbound-flight-information.indra.actions';
import { INDRADropdownService } from '@ibe.services/dropdown.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
var INDRAHeaderFallbackComponent = /** @class */ (function () {
    function INDRAHeaderFallbackComponent(router, route, modalService, sidebarService, store, storage, ibeAdminService, languageMarketService, locationService, headerService, location, paymentService, discountService, authenticationService, ibeAdminConfigService, urlService, bookingSearchService, dropdownService, parallelService) {
        var _this = this;
        this.router = router;
        this.route = route;
        this.modalService = modalService;
        this.sidebarService = sidebarService;
        this.store = store;
        this.storage = storage;
        this.ibeAdminService = ibeAdminService;
        this.languageMarketService = languageMarketService;
        this.locationService = locationService;
        this.headerService = headerService;
        this.location = location;
        this.paymentService = paymentService;
        this.discountService = discountService;
        this.authenticationService = authenticationService;
        this.ibeAdminConfigService = ibeAdminConfigService;
        this.urlService = urlService;
        this.bookingSearchService = bookingSearchService;
        this.dropdownService = dropdownService;
        this.parallelService = parallelService;
        this.htmlElement = document.getElementsByTagName('html');
        this.isAlive = true;
        this.headerItems = [
            { code: 'book', label: 'header.menu.book', link: '/booking', aria: 'header.aria.menu.book' },
            { code: 'myb', label: 'header.menu.myb', link: 'externalURLs.seeAllBookings', aria: 'header.aria.menu.myb' }
        ];
        this.userLoggedIn = true;
        this.userInfo = {
            miles: undefined,
            name: undefined,
            number: undefined,
            status: undefined,
            clubTap: undefined,
            clubTapExpireDate: undefined,
            defaultCurrency: undefined,
            initials: undefined
        };
        this.testeSVG = false;
        this.isDesktop$ = this.store.select(fromStore.isScreenDesktop);
        this.openUserItem = null;
        this.loading$ = this.store.select(fromStore.getUserLoading);
        this.logged_in$ = this.store.select(fromStore.getLoggedIn);
        this.user_info$ = this.store.select(fromStore.getUserInfo);
        this.country$ = this.store.select(fromStore.getUserCountry);
        this.language$ = this.store.select(fromStore.getUserLanguage);
        this.miles$ = this.store.select(fromStore.getOptionsBarPriceUnit);
        this.bookAwardFlights$ = this.store.select(fromStore.getFlightsFilterBookAwardFlights);
        this.current_page$ = this.store.select(fromStore.getSelectedBookingCurrentPage);
        this.promoCodesAndVoucher$ = this.store.select(fromStore.getSelectedPromoVouchers);
        this.confirmModalCallback$ = this.store.select(fromStore.getConfirmModalConfirm);
        this.userMarket$ = this.store.select(fromStore.getUserMarket);
        this.paymentMethods$ = this.store.select(fromStore.getPaymentMethods);
        this.booking_steps$ = this.store.select(fromStore.getSelectedBookingSteps);
        this.confirmModalCallback = '';
        this.languageRollback = false;
        this.deeplinkMarket$ = this.store.select(fromStore.getUserDeeplinkMarket);
        this.headerLoading = true;
        this.selectedCountryIndex = 47;
        this.selectedLanguageIndex = 0;
        this.showCountry = true;
        this.showCountryFlag = true;
        this.payWithMilesLanguages = [
            { label: 'header.menu.language.de', code: 'de' },
            { label: 'header.menu.language.en', code: 'en' },
            { label: 'header.menu.language.es', code: 'es' },
            { label: 'header.menu.language.fr', code: 'fr' },
            { label: 'header.menu.language.pt', code: 'pt' }
        ];
        this.countriesList = [];
        this.languageList = [];
        this.promoCodesAndVoucher = [];
        this.countryCurrencyList = [];
        this.allSubscriptions = [];
        this.currencyChecked = false;
        this.isLandingPage = false;
        this.nlfLoginDropdownEnabled = false;
        // to fix the issue where the deeplink market and language are not being applied
        if (this.location.path().includes('deeplink')) {
            var url = window.location.href;
            if (url.indexOf('market') !== -1 && url.indexOf('language') !== -1) {
                var market = this.urlService.INDRA_getUrlParams('market', url);
                var language = this.urlService.INDRA_getUrlParams('language', url);
                if (language && language.includes('-')) {
                    language = language.substring(0, 2);
                }
                else {
                    language = language && language !== 'null' && language.length > 0 ? language : DEFAULT_LANGUAGE;
                }
                if (market && market.toUpperCase() === 'UK') {
                    market = 'GB';
                }
                else if (market && market.toUpperCase() === 'RU') {
                    market = 'PT';
                }
                else {
                    market = market && market !== 'null' && market.length > 0 ? market.toUpperCase() : DEFAULT_MARKET;
                }
                if (language) {
                    sessionStorage.setItem('language', language);
                }
                if (market) {
                    sessionStorage.setItem('market', market);
                }
            }
        }
        this.miles$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.showCountry = !(value === 'miles');
            _this.showCountry = !(value === 'miles');
            if (value === 'cash') {
                _this.isChecked = false;
            }
            else if (value === 'miles') {
                _this.isChecked = true;
            }
        });
        this.confirmModalCallback$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                _this.confirmModalCallback = value;
            }
        });
        /*
        this.isCorporate$
            .pipe(takeWhile(() => this.isAlive))
            .subscribe(
                value => {
                    if (value === true) {
                        this.isCorporate = true;
                        this.headerItems[0] = { label: 'Book', link: '/corporate', aria: 'Book a flight' };
                        this.tapLogo = 'sprite.svg#logo--tap_corporate';
                        this.link = '/corporate';
                        this.showCountry = false;
                    } else {
                        this.isCorporate = false;
                        this.headerItems[0] = { label: 'Book', link: '/booking', aria: 'Book a flight' };
                        this.tapLogo = 'sprite.svg#logo--TAP-horizontal';
                        this.link = '/booking';
                        this.showCountry = true;
                    }
                }
            );
        */
        // Condition handling for displays the new tap logo
        if (this.openUserItem !== null && (this.openUserItem !== 'menu' && this.isDesktop)) {
            this.tapLogo = 'sprite.svg#logo--TAP-negative';
        }
        else {
            this.tapLogo = 'sprite.svg#logo--TAP-positive';
        }
        this.lottieConfigHamburgerMenu = {
            path: './assets/animations/hamburger-menu.json',
            renderer: 'svg',
            autoplay: false,
            loop: false
        };
        this.deeplinkMarket$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            if (value) {
                var hasLoadedGenerateFlag = _this.storage.get('hasLoadedGenerate');
                if (hasLoadedGenerateFlag) {
                    _this.INDRAGetPaymentMethods(value);
                }
            }
        });
    }
    INDRAHeaderFallbackComponent.prototype.ngOnInit = function () {
        var _this = this;
        // Get the current URL when the component is initialized
        this.router.events.subscribe(function (event) {
            if (event instanceof NavigationEnd) {
                _this.currentUrl = event.url;
            }
        });
        this.loading$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.headerLoading = value;
        });
        this.isDesktop$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            setTimeout(function () {
                _this.isDesktop = value;
            }, 0);
        });
        this.language$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.selectedLanguageIndex = value;
        });
        this.country$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.selectedCountryIndex = value;
        });
        this.userMarket$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.newUserMarket = value;
            if (value) {
                // dont call this on review page to prevent conflict with generate API
                // dont call this if deeplink, paymentMethods will be called after deeplink resolver finished calling 
                // market, this doesnt apply to payment and booking-view deeplinks
                if (_this.router.url !== '/booking/review-your-trip' && _this.router.url !== '/booking/time-to-think'
                    && !_this.location.path().includes('dates/deeplink') && !_this.location.path().includes('flights/deeplink')
                    && !_this.location.path().includes('flights-multicity/deeplink') && !_this.location.path().includes('flights-stopover/deeplink')
                    && !_this.location.path().includes('review-your-trip/deeplink')) {
                    _this.INDRAGetPaymentMethods(value);
                }
            }
        });
        this.paymentMethods$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            if (_this.router.url.includes('payment') && sessionStorage.getItem('dupeMarket')) {
                var newMarketIndex = _this.countriesList.findIndex(function (country) { return country.code === _this.newUserMarket; });
                _this.selectedCountryIndex = newMarketIndex;
                _this.INDRA_handleCountryClick(_this.newUserMarket, newMarketIndex);
                sessionStorage.removeItem('dupeMarket');
            }
        });
        this.user_info$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            if (value) {
                _this.userInfo.name = (value.firstName || value.lastName ? value.firstName + ' ' + value.lastName : '');
                _this.userInfo.miles = value.currentPoints ? value.currentPoints : '';
                _this.userInfo.number = (value.ffCarrier && value.ffNumber ? value.ffCarrier + " " + value.ffNumber : '');
                _this.userInfo.status = value.ffLevel ? value.ffLevel : '';
                _this.userInfo.clubTap = (value.loyaltyPack ? value.loyaltyPack : null);
                _this.userInfo.clubTapExpireDate = (value.loyaltyPackExpireDate ? value.loyaltyPackExpireDate : null);
                _this.userInfo.defaultCurrency = (value.defaultCurrency ? value.defaultCurrency : '');
                _this.token = value.flyTapLogin;
                _this.userInfo.initials = (value.firstName.charAt(0).toUpperCase() + value.lastName.charAt(0).toUpperCase());
            }
            else {
                _this.userInfo = {
                    miles: undefined,
                    name: undefined,
                    number: undefined,
                    status: undefined,
                    clubTap: undefined,
                    clubTapExpireDate: undefined,
                    defaultCurrency: undefined,
                    initials: undefined
                };
                _this.token = null;
            }
        });
        this.logged_in$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.userLoggedIn = value;
        });
        this.booking_steps$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.isLandingPage = value.length == 0;
        });
        this.current_page$
            .pipe(takeWhile(function () { return _this.isAlive; }))
            .subscribe(function (value) {
            _this.current_page = value;
            _this.isLandingPage = value == null || value === 'landing';
        });
        this.promoCodesAndVoucher$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.promoCodesAndVoucher = value;
        });
        // get user from session storage
        this.userData = this.storage.get('userData');
        if (this.userInfo.name === undefined && this.userData) {
            // dispatch user information again based on data retrieved from storage
            var _a = this.userData, userProfile = _a.userProfile, defaultCurrency = _a.defaultCurrency;
            this.store.dispatch(new UserActions.PutLoggedInAction(true));
            this.store.dispatch(new UserActions.PutUserInfoAction(__assign({}, userProfile, { defaultCurrency: defaultCurrency })));
            this.store.dispatch(new UserActions.PutUserPNRSAction(this.userData.userPnrs));
        }
        this.bookAwardFlights$.pipe(takeWhile(function () { return _this.isAlive; })).subscribe(function (value) {
            _this.bookAwardFlights = value;
            if (_this.bookAwardFlights) {
                _this.userData = _this.storage.get('userData'); // added to resolve booking market API not being called when user switches booking type during deeplink scenario
                if (_this.userData && _this.userData.country) {
                    _this.store.dispatch(new UserActions.PutMarketLoadingAction(true));
                    var market = sessionStorage.getItem('market');
                    sessionStorage.setItem('prevSelectedMarket', market);
                    var userMarket = _this.bookingSearchService.INDRA_getAwardBookingMarket(_this.userData.country);
                    _this.languageMarketService.setMarket(userMarket);
                    _this.store.dispatch(new UserActions.PutMarketAction(userMarket));
                    if (_this.languageList.length !== 0) {
                        _this.INDRA_getBookAwardsLanguage();
                    }
                    _this.INDRA_setBookingMarket(userMarket);
                }
                else {
                    // for cases where the user account does not have a defined user market
                    _this.store.dispatch(new UserActions.PutMarketLoadingAction(true));
                    var market = sessionStorage.getItem('market');
                    sessionStorage.setItem('prevSelectedMarket', market);
                    var userMarket = _this.bookingSearchService.INDRA_getAwardBookingMarket(null);
                    _this.languageMarketService.setMarket(userMarket);
                    _this.store.dispatch(new UserActions.PutMarketAction(userMarket));
                    if (_this.languageList.length !== 0) {
                        _this.INDRA_getBookAwardsLanguage();
                    }
                    _this.INDRA_setBookingMarket(userMarket);
                }
            }
            else {
                var previousMarket_1 = sessionStorage.getItem('prevSelectedMarket');
                if (previousMarket_1) {
                    _this.store.dispatch(new UserActions.PutMarketLoadingAction(true));
                    // restore previous market selected
                    _this.selectedCountryIndex = _this.countriesList.findIndex(function (country) { return country.code === previousMarket_1; });
                    _this.languageMarketService.setMarket(previousMarket_1);
                    _this.store.dispatch(new UserActions.PutMarketAction(previousMarket_1));
                    sessionStorage.removeItem('prevSelectedMarket');
                    if (_this.languageList.length !== 0) {
                        _this.INDRA_getBookAwardsLanguage();
                    }
                    var routeUrl = _this.currentUrl || _this.location.path();
                    if (!routeUrl.includes("/my-bookings/view/")) {
                        _this.INDRA_setBookingMarket(previousMarket_1);
                    }
                }
                else {
                    // ensure that is_market_loading property in store will always be reset to false
                    _this.store.dispatch(new UserActions.PutMarketLoadingAction(false));
                }
            }
            _this.INDRA_mapCurrency();
        });
        /*
         * - Get Currency from JSON file
         * - Get Market and Languages per Market from API
         * - Determine selected market and language (from session storage if existing, or defaults if not)
         * -  Save selected market, language and corresponding currency to session storage
         *
         * NOTE: This might be something that can be removed in the future as an improvement,
         *       and just reuse redux to store market, currency and language variables.
        */
        if (this.countriesList.length === 0) {
            this.headerLoading = true;
        }
        this.currencySubscription = this.languageMarketService.getCurrency().subscribe(function (countryList) {
            _this.countryCurrencyList = countryList;
            _this.getMarketSubscription = _this.languageMarketService.getMarkets().subscribe(function (markets) {
                // get if there is a selected market or language previously saved on session storage
                var selectedMarketCode = sessionStorage.getItem('market');
                var selectedLanguageCode = sessionStorage.getItem('language');
                // get languages list per market
                var languages = _this.languageMarketService.getLanguages(markets);
                _this.languageList = [];
                // get list of countries/markets and determine the selected index for market dropdown
                _this.countriesList = _this.languageMarketService.getCountryList(markets, languages);
                if (_this.countriesList) {
                    _this.headerLoading = false;
                }
                if (selectedMarketCode) {
                    _this.selectedCountryIndex = _this.countriesList.findIndex(function (country) { return country.code === selectedMarketCode; });
                }
                else {
                    var defaultlangMarket_1 = _this.languageMarketService.loadDefaultLanguageMarket();
                    _this.languageMarketService.getMarkets().subscribe(function (data) {
                        var market = data.find((function (item) { return item.marketCode === defaultlangMarket_1[1]; }));
                        if (market) {
                            _this.setMarketSubscription1 = _this.locationService.INDRA_setBookingMarket(market.marketCode, market.locales[0]).subscribe();
                            _this.languageMarketService.setMarket(market.marketCode);
                            _this.languageMarketService.setLanguage(market.locales[0]);
                        }
                        else {
                            _this.selectedCountryIndex = _this.countriesList.findIndex(function (country) { return country.code === DEFAULT_MARKET; });
                            if (_this.selectedCountryIndex > 0) {
                                selectedLanguageCode = _this.countriesList[_this.selectedCountryIndex].language[0].code;
                                _this.setMarketSubscription1 = _this.locationService.INDRA_setBookingMarket(_this.countriesList[_this.selectedCountryIndex].code, selectedLanguageCode).subscribe();
                                _this.languageMarketService.setMarket(_this.countriesList[_this.selectedCountryIndex].code);
                                _this.languageMarketService.setLanguage(selectedLanguageCode);
                            }
                        }
                    });
                }
                if (!_this.bookAwardFlights) {
                    // handle deeplink scenario (if market from deeplink is incorrect)
                    var deeplink = JSON.parse(sessionStorage.getItem('deepLink'));
                    if (_this.selectedCountryIndex === -1) {
                        _this.languageMarketService.setMarket(DEFAULT_MARKET);
                        if (deeplink) {
                            deeplink.market = DEFAULT_MARKET;
                            _this.storage.set('deepLink', deeplink);
                        }
                        _this.selectedCountryIndex = _this.countriesList.findIndex(function (country) { return country.code === DEFAULT_MARKET; });
                    }
                    // determine the selected language for the language dropdown and store in session storage
                    if (selectedLanguageCode &&
                        _this.countriesList[_this.selectedCountryIndex] &&
                        _this.countriesList[_this.selectedCountryIndex].language) {
                        var country = _this.countriesList[_this.selectedCountryIndex];
                        _this.selectedLanguageIndex = country.language.findIndex(function (lang) { return lang.code === selectedLanguageCode; });
                        // do this only when in deeplink scenario 
                        if (_this.location.path().includes('deeplink')) {
                            if (_this.selectedLanguageIndex === -1) {
                                _this.selectedLanguageIndex = 0;
                            }
                            var language = country.language[_this.selectedLanguageIndex];
                            var languageCode = language ? language.code : DEFAULT_LANGUAGE;
                            _this.headerService.setLanguage(languageCode);
                            _this.languageMarketService.setLanguage(languageCode);
                            if (deeplink) {
                                deeplink.language = languageCode;
                                _this.storage.set('deepLink', deeplink);
                                // this.ibeAdminService.loadTranslations('tap', TRANSLATION_MODULES_BOOKING_DETAILS_PAGE, language.code);
                            }
                        }
                        else {
                            _this.headerService.setLanguage(selectedLanguageCode);
                            _this.languageMarketService.setLanguage(selectedLanguageCode);
                        }
                    }
                    else {
                        // if no selected (e.g. during first access, use default)
                        _this.languageMarketService.setLanguage(DEFAULT_LANGUAGE);
                        _this.headerService.setLanguage(DEFAULT_LANGUAGE);
                    }
                    _this.languageList = _this.countriesList[_this.selectedCountryIndex].language;
                }
                _this.INDRA_getBookAwardsLanguage();
                // get currency of selected market and save in session storage
                _this.INDRA_mapCurrency();
                _this.ibeAdminService.loadTranslations('tap', ['header'], sessionStorage.getItem('language'));
            });
        });
        this.allSubscriptions.push(this.currencySubscription);
        this.allSubscriptions.push(this.getMarketSubscription);
        this.allSubscriptions.push(this.setMarketSubscription1);
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_setBookingMarket = function (market) {
        var _this = this;
        var language = sessionStorage.getItem('language');
        this.locationService.INDRA_setBookingMarket(market, language).subscribe(function (data) {
            sessionStorage.setItem('decimals', data ? data.decimals : undefined);
            _this.store.dispatch(new UserActions.PutMarketLoadingAction(false));
        }, function (err) {
            _this.store.dispatch(new UserActions.PutMarketLoadingAction(false));
        });
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_getBookAwardsLanguage = function () {
        if (this.bookAwardFlights) {
            this.languageList = this.payWithMilesLanguages;
            var currentLanguage = sessionStorage.getItem('language');
            var reg_1 = currentLanguage.split('-');
            var languageIdx = this.payWithMilesLanguages.findIndex(function (cur) { return cur.code === reg_1[0]; });
            if (languageIdx !== -1) {
                sessionStorage.setItem('prevSelectedLanguage', currentLanguage);
                this.store.dispatch(new UserActions.PutLanguageAction(languageIdx));
                this.languageMarketService.setLanguage(currentLanguage);
                this.headerService.setLanguage(currentLanguage);
                this.ibeAdminService.reloadTranslations('tap', currentLanguage);
            }
            else {
                sessionStorage.setItem('prevSelectedLanguage', currentLanguage);
                var enIdx = this.languageList.findIndex(function (lang) { return lang.code === 'en'; });
                this.store.dispatch(new UserActions.PutLanguageAction(enIdx));
                this.languageMarketService.setLanguage(this.languageList[enIdx].code);
                this.headerService.setLanguage(this.languageList[enIdx].code);
                this.ibeAdminService.reloadTranslations('tap', this.languageList[enIdx].code);
            }
        }
        else {
            var prevLanguage = sessionStorage.getItem('prevSelectedLanguage');
            if (this.languageList) {
                if (prevLanguage) {
                    var currentLanguage_1 = prevLanguage;
                    this.languageList = this.countriesList[this.selectedCountryIndex].language;
                    var languageIndex = this.languageList.findIndex(function (cur) { return cur.code === currentLanguage_1; });
                    this.store.dispatch(new UserActions.PutLanguageAction(languageIndex));
                    this.languageMarketService.setLanguage(currentLanguage_1);
                    this.headerService.setLanguage(currentLanguage_1);
                    this.ibeAdminService.reloadTranslations('tap', currentLanguage_1);
                }
            }
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_mapCurrency = function () {
        var _this = this;
        // if award booking use currency of the award market
        if (this.bookAwardFlights) {
            var userData = this.storage.get('userData');
            var userMarket = this.bookingSearchService.INDRA_getAwardBookingMarket(userData ? userData.country : null);
            sessionStorage.setItem('currency', this.bookingSearchService.INDRA_getAwardBookingCurrency(userMarket));
        }
        else {
            this.countryCurrencyList.forEach(function (market) {
                var selected = _this.countriesList[_this.selectedCountryIndex];
                if (market.code === selected.code) {
                    sessionStorage.setItem('currency', market.currency);
                }
            });
        }
    };
    INDRAHeaderFallbackComponent.prototype.ngOnDestroy = function () {
        this.isAlive = false;
        for (var _i = 0, _a = this.allSubscriptions; _i < _a.length; _i++) {
            var sub = _a[_i];
            if (sub) {
                sub.unsubscribe();
            }
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_isActiveRouter = function (item) {
        return this.router.url.includes(item.link);
        /*
        from post-sprint 8 client code merge (replace line above)
        const isConfirmationPage = this.router.url.includes('/my-bookings/view/');

        if (!isConfirmationPage) {
            return this.router.url.includes(item.link);
        } else if (item.link === '/booking' || item.link === '/corporate') {
            return true;
        }
        */
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleUserClick = function (userItem, boolean) {
        if (this.router.url.includes('/notavailable')) {
            return;
        }
        if (this.location.path() != '/booking' && (userItem == 'country' || userItem == 'language')) {
            return;
        }
        else {
            if (!this.userLoggedIn && userItem === 'user-info') {
                // Open Login Modal
                this.showLoginModal();
            }
            else {
                if (this.openUserItem === userItem) {
                    this.INDRA_handleClose();
                }
                else {
                    this.openUserItem = userItem;
                    // Disable scroll on body mobile
                    this.htmlElement[0].classList.add('no-scroll-mobile');
                    if (userItem === 'menu') {
                        this.animateHamburgerMenu('open');
                        // Disable scroll on body
                        this.htmlElement[0].classList.add('no-scroll');
                    }
                }
            }
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_isVisible = function () {
        if (this.location.path() != '/booking') {
            return false;
        }
        else {
            return true;
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleClose = function () {
        if (this.openUserItem === 'menu') {
            this.animateHamburgerMenu('close');
            // Enable scroll on body again
            this.htmlElement[0].classList.remove('no-scroll');
        }
        this.openUserItem = null;
        // Enable scroll on body mobile again
        this.htmlElement[0].classList.remove('no-scroll-mobile');
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleItemClick = function (link, item) {
        if (this.router.url.includes('/notavailable') && (!item || item && item.code !== 'myb')) {
            return;
        }
        this.INDRA_handleClose();
        this.store.dispatch(new FlightInformationActions.ResetAction);
        this.store.dispatch(new OutboundFlightInformationActions.ResetOutboundFlightInformationAction);
        this.store.dispatch(new InboundFlightInformationActions.ResetInboundFlightInformationAction);
        if (item && item.code == 'myb') {
            var url = this.ibeAdminConfigService.getConfigurationValue(item.link);
            url += '?source=flytap';
            var selectedMarketCode = sessionStorage.getItem('market');
            var selectedLanguageCode = sessionStorage.getItem('language');
            if (selectedMarketCode) {
                url += '&market=' + selectedMarketCode;
            }
            if (selectedLanguageCode) {
                url += '&language=' + selectedLanguageCode;
            }
            if (this.token) {
                url += '&uid=' + this.token;
            }
            window.open(url);
            return;
        }
        this.router.navigate([link]);
    };
    // Sprint 4 Merge note: this commented out method is a replacement for the INDRA_handleItemClick method
    // Note: Method updated on Post Sprint 8 merge
    /*
    TAP_handleItemClick(link) {
        if (!link)
            link = this.link;
        this.TAP_handleClose();
        const activeBooking = this.bookingSteps.length > 0;
        if (activeBooking) {
            this.modalService.assignComponent(NavigateAwayModalComponent);
            this.modalService.open();

            this.modalService.navigateAwaySelection$
                .pipe(takeWhile(() => this.isAlive))
                .subscribe(
                    value => {
                        if (value) {
                            this.store.dispatch(new MiniIBEActions.Reset());
                            this.store.dispatch(new BookingStepsActions.ResetAction());
                            this.router.navigate([link]);
                        }
                    }
                );
        } else {
            this.store.dispatch(new MiniIBEActions.Reset());
            this.router.navigate([link]);
        }
    }

    */
    // Method handler for displays the new tap logo
    INDRAHeaderFallbackComponent.prototype.TAP_getLogo = function () {
        return this.tapLogo;
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printStatusLogo = function () {
        switch (this.userInfo.status) {
            case TAP_HEADER_MILES_AND_GO_MILES:
            case TAP_HEADER_MILES_AND_GO_MILS:
                return 'loyalty--miles_go';
            case TAP_HEADER_MILES_AND_GO_SILVER:
                return 'loyalty--miles_go_silver';
            case TAP_HEADER_MILES_AND_GO_GOLD:
                return 'loyalty--miles_go_gold';
            case TAP_HEADER_MILES_AND_GO_NAVIGATOR:
            case TAP_HEADER_MILES_AND_GO_HONORARY_GOLD:
                return 'loyalty--navigator';
            /*
            case 'plus':
                return 'logo--corporate-plus--loyalty';
            case 'top':
                return 'logo--corporate-top--loyalty';
            case 'corporate':
                return 'logo--corporate--loyalty';
            */
            default:
                return 'loyalty--miles_go';
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printStatusAriaLabel = function () {
        switch (this.userInfo.status) {
            case TAP_HEADER_MILES_AND_GO_MILES:
            case TAP_HEADER_MILES_AND_GO_MILS:
                return 'Miles&Go';
            case TAP_HEADER_MILES_AND_GO_SILVER:
                return 'Miles&Go Silver';
            case TAP_HEADER_MILES_AND_GO_GOLD:
                return 'Miles&Go Gold';
            case TAP_HEADER_MILES_AND_GO_NAVIGATOR:
            case TAP_HEADER_MILES_AND_GO_HONORARY_GOLD:
                return 'Navigator';
            /*
            case 'plus':
                return 'Tap Corporate PLUS';
            case 'top':
                return 'Tap Corporate TOP';
            case 'corporate':
                return 'Tap Corporate';
            */
            default:
                return 'Miles&Go';
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printClubLogoClass = function () {
        if (!this.userInfo.clubTap) {
            return '';
        }
        return this.userInfo.clubTap.toLowerCase();
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printClubLogo = function () {
        if (!this.userInfo.clubTap) {
            return '';
        }
        var club_tap = this.userInfo.clubTap;
        switch (club_tap) {
            case TAP_HEADER_CLUB_TAP_BASIC:
                return 'logo--club_tap_basic';
            case TAP_HEADER_CLUB_TAP_EXTRA:
                return 'logo--club_tap_extra';
            case TAP_HEADER_CLUB_TAP_TOP:
                return 'logo--club_tap_top';
            case TAP_HEADER_CLUB_TAP_PLATINUM:
                return 'logo--club_tap_platinum';
            case TAP_HEADER_CLUB_TAP_PLATINUM_PLUS:
                return 'logo--club_tap_platinum_plus';
            case TAP_HEADER_CLUB_TAP_DIAMOND:
                return 'logo--club_tap_diamond';
            default:
                return '';
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printClubStatusAriaLabel = function () {
        if (!this.userInfo.clubTap) {
            return '';
        }
        var club_tap = this.userInfo.clubTap;
        switch (club_tap) {
            case TAP_HEADER_CLUB_TAP_BASIC:
                return 'Club Basic';
            case TAP_HEADER_CLUB_TAP_EXTRA:
                return 'Club Extra';
            case TAP_HEADER_CLUB_TAP_PLATINUM:
                return 'Club Platinum';
            case TAP_HEADER_CLUB_TAP_TOP:
                return 'Club Top';
            case TAP_HEADER_CLUB_TAP_PLATINUM_PLUS:
                return 'Club Platinum +';
            case TAP_HEADER_CLUB_TAP_DIAMOND:
                return 'Club Diamond';
            default:
                return 'Club TAP';
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_printUserAriaLabel = function () {
        if (this.userLoggedIn) {
            return this.INDRA_getTranslationKey('header.aria.openUserInfo');
        }
        else {
            return this.INDRA_getTranslationKey('header.aria.openUserRegister');
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_currencyCheck = function (country, index, previousIndex) {
        var _this = this;
        if (this.promoCodesAndVoucher) {
            var selected_1 = this.countriesList[index];
            var selectedMarket_1 = this.countryCurrencyList.filter(function (market) { return market.code === selected_1.code; });
            var invalidDiscounts_1 = this.promoCodesAndVoucher.filter(function (discount) { return discount.currencyCode !== selectedMarket_1[0].currency; });
            if (invalidDiscounts_1.length !== 0) {
                var bodyMsg = void 0;
                if (this.bookAwardFlights) {
                    bodyMsg = this.INDRA_getTranslationKey('header.aria.invalidCountryBookingAward');
                }
                else {
                    bodyMsg = this.INDRA_getTranslationKey('header.aria.invalidCountryBooking');
                }
                this.store.dispatch(new ConfirmModalActions.PutTitle(this.INDRA_getTranslationKey('header.title.changingCountry')));
                this.store.dispatch(new ConfirmModalActions.PutBodyMsg(bodyMsg));
                this.store.dispatch(new ConfirmModalActions.PutOkLabel(this.INDRA_getTranslationKey('header.text.continueToNewCountry')));
                this.store.dispatch(new ConfirmModalActions.PutCancelLabel(this.INDRA_getTranslationKey('header.text.keepTheDiscount')));
                this.modalService.assignComponent(INDRAConfirmModalComponent);
                this.modalService.open();
                this.modalService.isOpen
                    .pipe(takeWhile(function () { return _this.isAlive; }))
                    .subscribe(function (value) {
                    if (!value) {
                        if (_this.confirmModalCallback === 'ok') {
                            invalidDiscounts_1.forEach(function (discount) {
                                _this.removeVoucherSubscription = _this.discountService.INDRA_removeVoucherInSession(discount.code).subscribe(function (voucher) {
                                    if (voucher.status === '200') {
                                        var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                        _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                        _this.promoCodesAndVoucher = currDiscountList;
                                        _this.currencyChecked = true;
                                    }
                                    else {
                                        _this.removePromocodeSubscription = _this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(function (promo) {
                                            if (promo.data || promo.status === '406') {
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                            else {
                                                /** temporary remove discount in front */
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                        }, function (err) {
                                            if (err) {
                                                /** temporary remove discount in front */
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                        });
                                    }
                                }, function (error) {
                                    if (error) {
                                        _this.removePromocodeSubscription = _this.discountService.INDRA_removePromoCodeInSession(discount.code).subscribe(function (promo) {
                                            if (promo.status === '200' || promo.status === '406') {
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                            else {
                                                // ** temporary remove discount in front */ 
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                        }, function (err) {
                                            if (err) {
                                                /** temporary remove discount in front */
                                                var currDiscountList = _this.promoCodesAndVoucher.filter(function (x) { return x.code !== discount.code; });
                                                _this.store.dispatch(new PromoVoucherActions.PutPromoVouchersAction(currDiscountList));
                                                _this.promoCodesAndVoucher = currDiscountList;
                                                _this.currencyChecked = true;
                                            }
                                        });
                                    }
                                });
                            });
                            _this.currencyChecked = true;
                            _this.INDRA_handleCountryClick(country, index);
                        }
                        else {
                            _this.currencyChecked = true;
                            _this.languageRollback = true;
                            var countryCode = _this.countriesList[previousIndex].code;
                            _this.INDRA_handleCountryClick(countryCode, previousIndex);
                        }
                    }
                });
            }
            else {
                this.currencyChecked = true;
                this.INDRA_handleCountryClick(country, index);
            }
        }
        else {
            this.currencyChecked = true;
            this.INDRA_handleCountryClick(country, index);
        }
        this.allSubscriptions.push(this.removeVoucherSubscription);
        this.allSubscriptions.push(this.removePromocodeSubscription);
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleCountryClick = function (country, index) {
        var _this = this;
        var previousSelectedCountryIndex = this.selectedCountryIndex;
        var previouslySelectedLanguageIndex = this.selectedLanguageIndex;
        if (!this.currencyChecked) {
            this.INDRA_currencyCheck(country, index, previousSelectedCountryIndex);
        }
        else {
            this.selectedCountryIndex = index;
            this.languageList = this.countriesList[index].language;
            if (!this.countriesList ||
                !this.countriesList[this.selectedCountryIndex] ||
                !this.countriesList[this.selectedCountryIndex].language ||
                !this.countriesList[index].language ||
                this.countriesList[index].language.length === 0) {
                return;
            }
            var defaultLanguage = this.countriesList[index].language[0].code;
            this.setMarketSubscription2 = this.locationService.INDRA_setBookingMarket(country, defaultLanguage).subscribe(function (data) {
                _this.selectedCountryIndex = index;
                if (_this.languageRollback === true) {
                    _this.selectedLanguageIndex = previouslySelectedLanguageIndex;
                }
                else {
                    _this.selectedLanguageIndex = 0;
                }
                var initialLanguage = _this.countriesList[_this.selectedCountryIndex].language[_this.selectedLanguageIndex].code;
                // store market and language to session storage
                _this.languageMarketService.setMarket(country);
                _this.languageMarketService.setLanguage(initialLanguage);
                sessionStorage.setItem('decimals', data ? data.decimals : undefined);
                // map currency based on selected market and get translations for the selected language fromIBE Admin
                _this.INDRA_mapCurrency();
                _this.ibeAdminService.reloadTranslations('tap', initialLanguage);
                _this.INDRA_handleClose();
                // Update store
                _this.store.dispatch(new UserActions.PutCountryAction(_this.selectedCountryIndex));
                _this.store.dispatch(new UserActions.PutLanguageAction(_this.selectedLanguageIndex));
                _this.store.dispatch(new UserActions.PutMarketAction(_this.countriesList[_this.selectedCountryIndex].code));
                _this.currencyChecked = false;
            }, function (err) {
                _this.INDRA_handleClose();
            });
            this.allSubscriptions.push(this.setMarketSubscription2);
            // Fix IE flag change
            this.showCountryFlag = false;
            clearTimeout(this.showCountryFlagTimeout);
            this.showCountryFlagTimeout = setTimeout(function () {
                _this.showCountryFlag = true;
            }, 10);
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleLanguageClick = function (language, index) {
        this.selectedLanguageIndex = index;
        var changed = language !== sessionStorage.getItem('language'); // check if no change was done
        this.languageMarketService.setLanguage(language);
        this.ibeAdminService.reloadTranslations('tap', language);
        if (changed) {
            // this.INDRA_getHeader();
            this.headerService.setLanguage(language);
        }
        // Update store
        this.store.dispatch(new UserActions.PutLanguageAction(this.selectedLanguageIndex));
        this.INDRA_handleClose();
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_handleLogout = function () {
        var _this = this;
        this.authenticationService.INDRA_logout().subscribe(function (res) {
            if (res && res.status == '200') {
                var navigate = _this.bookAwardFlights;
                // Update store
                _this.store.dispatch(new UserActions.PutLoggedInAction(!_this.userLoggedIn));
                _this.store.dispatch(new UserActions.PutUserInfoAction(false));
                _this.store.dispatch(new UserActions.PutCancelLogIn(false));
                _this.store.dispatch(new FlightsFilterActions.PutBookAwardFlights(false));
                _this.store.dispatch(new OptionsBarActions.PutPriceUnit('cash'));
                _this.storage.remove('userData');
                _this.storage.remove('user_info');
                _this.storage.remove('prevSelectedLanguage');
                _this.userInfo = {
                    miles: undefined,
                    name: undefined,
                    number: undefined,
                    status: undefined,
                    clubTap: undefined,
                    clubTapExpireDate: undefined,
                    defaultCurrency: undefined,
                    initials: undefined
                };
                if (_this.current_page === 'dates' || _this.current_page === 'flights') {
                    if (navigate)
                        _this.router.navigate(['/booking']);
                }
            }
            _this.INDRA_handleClose();
        }, function (err) {
            _this.INDRA_handleClose();
        });
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_openMarketLanguageSidebar = function () {
        if (this.location.path() != '/booking') {
            return;
        }
        this.sidebarService.openSidebar(['market-language']);
    };
    INDRAHeaderFallbackComponent.prototype.showLoginModal = function () {
        this.modalService.assignComponent(INDRALoginModalComponent);
        this.modalService.open();
    };
    INDRAHeaderFallbackComponent.prototype.INDRAGetPaymentMethods = function (market) {
        var _this = this;
        this.parallelService.INDRA_setIsPaymentMethodLoading(true);
        // const market  = sessionStorage.getItem('market') ? sessionStorage.getItem('market') : DEFAULT_MARKET;
        this.paymentMethodSubscription =
            this.paymentService.INDRAGetPaymentMethods(market).subscribe(function (response) {
                _this.parallelService.INDRA_setIsPaymentMethodLoading(false);
                if (response && response.status == '200') {
                    // store payment session ID in session storage
                    sessionStorage.setItem(SESSION_VAR_KEY_PAYMENT_SESSION_ID, response.paymentSessionID);
                    sessionStorage.setItem('payment-methods', JSON.stringify(response));
                    // get list of payment methods
                    if (response.data && response.data.fops && response.data.fops.length > 0) {
                        _this.store.dispatch(new PaymentMethodsActions.PutPaymentMethodsAction(response.data));
                    }
                    else {
                        _this.store.dispatch(new PaymentMethodsActions.PutPaymentMethodsAction(null));
                    }
                }
                else {
                    _this.store.dispatch(new PaymentMethodsActions.PutPaymentMethodsAction(null));
                }
            }, function (error) {
                _this.store.dispatch(new PaymentMethodsActions.PutPaymentMethodsAction(null));
            });
        this.allSubscriptions.push(this.paymentMethodSubscription);
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_showLogout = function () {
        if (this.bookAwardFlights && (this.router.url.includes('review-your-trip') || this.router.url.includes('extras-to-your-trip') || this.router.url.includes('payment'))) {
            return false;
        }
        else if (this.router.url.includes('booking/payment')) {
            return false;
        }
        else {
            return true;
        }
    };
    INDRAHeaderFallbackComponent.prototype.handleHamburgerMenuAnimation = function (anim) {
        this.animationHamburgerMenu = anim;
        this.animationHamburgerMenu.setSpeed(1.5);
    };
    INDRAHeaderFallbackComponent.prototype.animateHamburgerMenu = function (event) {
        if (event === 'open') {
            this.animationHamburgerMenu.playSegments([8, 40], true);
        }
        else {
            this.animationHamburgerMenu.playSegments([68, 100], true);
        }
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_getTranslationKey = function (key) {
        return this.ibeAdminService.getTranslationValue(key);
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_getCountryTranslation = function (key) {
        var label = key ? key : this.languageList && this.languageList[this.selectedLanguageIndex] ? this.languageList[this.selectedLanguageIndex].label : '';
        if (!label) {
            return;
        }
        if (label == 'header.menu.language.pt-br') {
            var result = this.ibeAdminService.getTranslationValue('header.menu.language.pt_br');
            if (result == 'header.menu.language.pt_br') {
                return this.ibeAdminService.getTranslationValueAsync(label);
            }
            if (typeof result !== 'object') {
                return of(result);
            }
            return this.ibeAdminService.getTranslationValueAsync(label);
        }
        return this.ibeAdminService.getTranslationValueAsync(label);
    };
    INDRAHeaderFallbackComponent.prototype.INDRA_getLanguageCode = function (key) {
        var label = key ? key : this.languageList && this.languageList[this.selectedLanguageIndex] ? this.languageList[this.selectedLanguageIndex].code : '';
        if (!label) {
            return;
        }
        // Return first 2 character of string to fit the button
        // PT-BR -> PT, EN-US -> EN
        return label.substring(0, 2).toUpperCase();
    };
    INDRAHeaderFallbackComponent.prototype.ngAfterViewInit = function () {
        this.triggerDropdown();
    };
    INDRAHeaderFallbackComponent.prototype.triggerDropdown = function () {
        if (this.userLoggedIn) {
            return;
        }
        this.dropdownService.toggle('loginDropdown');
    };
    return INDRAHeaderFallbackComponent;
}());
export { INDRAHeaderFallbackComponent };
